import React from "react";
import Shadow from "../Shadow";
import RadioBox from "../forms/RadioBox";
import ProcessingBtns from "./ProcessingBtns";
import { IProcessing } from "../../../types";
const Processing = ({
  proc,
  resetForm,
  shadowFalse,
  hasDepth,
  hasProcessing,
  hasFormat,
  shadow,
}) => {
  const processing: IProcessing[] = proc;
  const reload = () => {
    shadowFalse(4);
    resetForm(["processingValue"]);
  };
  const reload2 = () => {
    shadowFalse(5);
    shadowFalse(6);
    shadowFalse(7);
    shadowFalse(8);
  };
  return (
    <div className={"bl_4_grid_item"}>
      {shadow && <Shadow />}
      <div className="calc_title_box">
        <div className="calc_title">Обработка</div>
        {processing
          .filter((el) => {
            if (
              el.formats.length &&
              !el.formats.some((f) => f.name === hasFormat)
            )
              return false;
            else if (el.processing_depths.length) {
              if (
                !el.processing_depths.some((p) => {
                  return p.millimetre === +hasDepth;
                })
              )
                return false;
            }
            return true;
          })
          .map((el) => {
            const data = el;
            const norm = data.processing_depths.find(
              (el) => hasDepth === el.millimetre.toString(),
            );
            const additional = norm?.processing_prices;
            return (
              <div key={el.id}>
                <RadioBox
                  info={{ text: data.description, img: data.photo }}
                  name="processing"
                  value={data.title}
                  func={additional?.length ? reload : reload2}
                  txt={data.title}
                />
                {additional?.length && hasProcessing === data.title ? (
                  <ProcessingBtns
                    hasDepth={hasDepth}
                    reload={reload2}
                    facet={additional.map((el) => el.title)}
                  />
                ) : (
                  <></>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Processing;
